// The reaction palette every chat surface offers. It mirrors the backend's
// allowlist (helpers/chatReactions.js) — anything outside it is refused
// there, so the picker must not offer more than this.
export const REACTION_EMOJI = ["👍", "❤️", "😂", "😮", "😢", "🙏", "👀", "✅", "🔥"];

// Two of the palette double as a support status on a customer's message:
// 👀 "looking into it", ✅ "done". Support sets them with one click in the
// admin console (the second replaces the first); every surface labels the
// chip so a customer reads it as a status, not a random emoji.
export const STATUS_REACTIONS = [
  { emoji: "👀", label: "Looking into it", mark: "Mark as looking into it" },
  { emoji: "✅", label: "Done", mark: "Mark as done" },
];

export function reactionLabel(emoji) {
  return STATUS_REACTIONS.find((status) => status.emoji === emoji)?.label || "";
}

// Chip tooltip: the status wording for 👀/✅ ("Support: looking into it"),
// plain toggle wording for the rest.
export function reactionTitle(reaction, { supportSide = false } = {}) {
  const label = reactionLabel(reaction?.emoji);
  if (label) {
    const who = supportSide ? "" : "Support: ";
    return reaction?.mine ? `${label} — click to remove` : `${who}${label}`;
  }
  return reaction?.mine ? "Remove your reaction" : `React with ${reaction?.emoji || ""}`;
}

// Whether the viewer's own status mark on this message is `emoji`.
export function hasMyReaction(message, emoji) {
  return messageReactions(message).some((reaction) => reaction.emoji === emoji && reaction.mine);
}

// Reactions arrive serialized as [{ emoji, count, mine }]. An older row (or a
// message echoed from a client that predates them) may carry nothing.
export function messageReactions(message) {
  return Array.isArray(message?.reactions) ? message.reactions : [];
}

// A short, one-line preview of the message being answered, for the quote
// above a bubble and the "Replying to…" bar over the composer.
export function replySnippet(target, max = 110) {
  if (!target) return "";
  if (target.deleted) return "Message deleted";
  const text = String(target.text ?? target.content ?? "").replace(/\s+/g, " ").trim();
  if (text) return text.length > max ? `${text.slice(0, max - 1)}…` : text;
  if (target.attachment || target.attachmentUrl) return "📷 Image";
  return "…";
}
